export const EXCLUDES_TAXES_AND_FEES = 'Excludes taxes and fees';
export const INCLUDES_TAXES_AND_FEES = 'Includes estimated taxes and fees';

export const FINANCING_DISCLAIMER =
  'Financing is subject to final deal terms with the dealer and subject to formal credit approval.';
